'use strict';
import React from 'react';

export default class Layout extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {
        return(
            <div className="container">
                { /* Entry point for React Router */ }
                {this.props.children}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/react/Layout.jsx